module.exports = __webpack_public_path__ + "static/media/facebook-icon.c762a3e9.svg";